import React from 'react';
import clsx from 'clsx';

import CommonCheckbox from '../common-checkbox/CommonCheckbox';
import HighlightedText from '../highlighted-text/HighlightedText';

import scss from './ProjectsSelect.module.scss';

function ProjectSelectItem({ name, id, enabled, checked, onSelect, searchStr }) {
  const handleSelect = (e) => {
    e.stopPropagation();
    if (enabled) {
      onSelect({ checked: !checked, id });
    }
  };

  return (
    <li
      className={clsx(
        scss.projectRow,
        checked && scss['projectRow--selected'],
        !enabled && scss['projectRow--disabled'],
      )}
      onClick={handleSelect}
      role='presentation'>
      <HighlightedText value={name} searchTerm={searchStr} className={scss.projectName} />
      <CommonCheckbox checked={checked} readonly disabled={!enabled} />
    </li>
  );
}

export default ProjectSelectItem;
